import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AboutHeroComponent } from './components/about-hero/about-hero.component';
import { AboutCommunitySectionComponent } from './components/about-community-section/about-community-section.component';
import { AboutCommunityMetricCardComponent } from './components/about-community-metric-card/about-community-metric-card.component';
import { AboutWalkSectionComponent } from './components/about-walk-section/about-walk-section.component';
import { AboutWalkCardComponent } from './components/about-walk-card/about-walk-card.component';
import { AboutFounderSectionComponent } from './components/about-founder-section/about-founder-section.component';
import { AboutCtaSectionComponent } from './components/about-cta-section/about-cta-section.component';

import { AboutComponent } from '../../pages/about/about.component';

@NgModule({
  declarations: [
    AboutHeroComponent,
    AboutCommunitySectionComponent,
    AboutCommunityMetricCardComponent,
    AboutWalkSectionComponent,
    AboutWalkCardComponent,
    AboutFounderSectionComponent,
    AboutCtaSectionComponent,
    AboutComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [
    AboutComponent,
  ],
})
export class AboutModule { }
